<template>
  <div class="rate-value-adds" v-if="value_adds.length">
    <b-alert
      show
      v-for="(value_add, index) in value_adds"
      :key="index" variant="success"
    >
      {{ value_add.description }}
    </b-alert>
  </div>
</template>

<script>

export default {
  name: 'rate-value-adds',

  components: {
  },

  props: {
    value_adds: Array
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .rate-value-adds {
    margin-bottom: $grid-gutter-width / 3;

    .alert {
      font-size: $font-size-md;
      padding: 0 5px;
      border-radius: 5px;
      display: inline-block;
      margin-bottom: 0;
      margin-left: $grid-gutter-width / 3;

      &:first-child {
        margin-left: 0;
      }
    }
  }

</style>